var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-loader',{attrs:{"speed":2,"animate":true,"height":_vm.totalHeight,"primaryColor":_vm.primaryColor,"secondaryColor":_vm.secondaryColor}},_vm._l((_vm.items),function(height,i){return _c('rect',{key:i,attrs:{"x":"0","y":_vm.getY(i),"rx":"2","ry":"2","width":"100%","height":height}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }